import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { parse } from '@atlassian/cs-ari';
export var parseExtensionId = function parseExtensionId(extensionId) {
  var ari = parse(extensionId);
  var _split = ari.resourceId.split('/'),
    _split2 = _slicedToArray(_split, 4),
    appId = _split2[0],
    environmentId = _split2[1],
    groupId = _split2[2],
    moduleKey = _split2[3];
  return {
    appId: appId,
    environmentId: environmentId,
    groupId: groupId,
    moduleKey: moduleKey
  };
};